import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { plainToClass } from 'class-transformer';
// Constant imports
import { URLConstants } from '../../../../_constants/url-constants';
import { EntityClosedBookPeriodResultDto } from '../../_models/common/entity-closed-book-period-result-dto';
import { EntityFisicalYearResultDto } from '../../_models/common/entity-fisical-year-result-dto';
import { ReverseEditorResultDto } from '../../../../shared-module/_models/reverse-editor-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CBSharedService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getEntityClosedBookPeriod(params) {
        const url = URLConstants.ccCBGLOpenCloseBooksApiUrl + `/closedperiod${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((plain) => plainToClass(EntityClosedBookPeriodResultDto, plain)));
    }
    getEntityFiscalYear(params) {
        const url = URLConstants.ccCBGLOpenCloseBooksApiUrl + `/fiscalyear${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((plain) => plainToClass(EntityFisicalYearResultDto, plain)));
    }
    getEntityReverseEditor(params) {
        const url = URLConstants.ccInvoiceApiUrl + `/reverse/editor${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((plain) => plainToClass(ReverseEditorResultDto, plain)));
    }
}
CBSharedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CBSharedService_Factory() { return new CBSharedService(i0.ɵɵinject(i1.HttpClient)); }, token: CBSharedService, providedIn: "root" });
